import {useMemo} from 'react';
import {PaymentsCart, RESERVATION_PAYMENT_TYPES} from '@guestapp/sdk';
import {getTotalPayNow} from 'utils/payments';

type Props = {
  paymentsCart?: PaymentsCart;
};
function useBuildTotalPayments({paymentsCart}: Props) {
  const depositPaymentItem = paymentsCart?.pay_now_payments?.find(
    payment => payment.obj_type === RESERVATION_PAYMENT_TYPES.securityDeposit,
  );

  const depositFee =
    depositPaymentItem?.payment_type === 'PRE_AUTH_PAYMENT'
      ? parseFloat(depositPaymentItem?.commission_amount ?? '0')
      : 0;
  const totalDepositAmount = parseFloat(depositPaymentItem?.amount ?? '0').toFixed(2);

  const totalToPayNow = useMemo(
    () =>
      getTotalPayNow(
        depositFee,
        paymentsCart?.total_amount_to_pay,
        paymentsCart?.outside_paid_amount,
      ),
    [depositFee, paymentsCart?.total_amount_to_pay, paymentsCart?.outside_paid_amount],
  );

  return {
    totalToPayNow,
    totalDepositAmount,
  };
}

export {useBuildTotalPayments};
